import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  AuthGuard,
  CmsConfig,
  DeferLoadingStrategy,
  FeaturesConfig,
  I18nModule,
  provideConfig,
  UrlModule,
} from '@spartacus/core';
import {
  CmsPageGuard,
  GenericLinkModule,
  IconModule,
  MediaModule,
  OutletRefModule,
  PageLayoutComponent,
} from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrderDetailsService } from '../../../../service/myaccount/order-details.service';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { TooltipTextModule } from '../../tooltip-text/tooltip-text.module';
import { MyAccountPermissionsAuthGuard } from '../guards/myaccount-permissions-auth.guard';
import { CancelEditOrderModalComponent } from './cancel-edit-order-modal/cancel-edit-order-modal.component';
import { OrderDetailSummaryComponent } from './order-detail-summary/order-detail-summary.component';
import { OrderDetailsBackorderComponent } from './order-details-backorder/order-details-backorder.component';
import { OrderDetailsConsignmentsComponent } from './order-details-consignments/order-details-consignments.component';
import { OrderDetailsInvoiceComponent } from './order-details-invoice/order-details-invoice.component';
// tslint:disable-next-line: max-line-length
import { MatExpansionModule } from '@angular/material/expansion';
import { LaunchDialogModalLayoutConfig } from 'src/app/dialog/custom-launch-dialog-config';
import { OrderDetailsAuthGuard } from './guards/order-details-auth.guard';
import { OrderDetailsPaymentReturnComponent } from './order-details-payment-return/order-details-payment-return.component';
import { SnappayOrderDetailsInvoiceComponent } from './snappay-order-details-invoice/snappay-order-details-invoice.component';
const moduleComponents = [
  OrderDetailSummaryComponent,
  OrderDetailsInvoiceComponent,
  SnappayOrderDetailsInvoiceComponent,
  OrderDetailsPaymentReturnComponent,
  OrderDetailsConsignmentsComponent,
  OrderDetailsBackorderComponent,
  CancelEditOrderModalComponent,
];

@NgModule({
  imports: [
    CommonModule,
    OutletRefModule,
    I18nModule,
    MatIconModule,
    MatTooltipModule,
    IconModule,
    MediaModule,
    UrlModule,
    SharedModule,
    MatProgressSpinnerModule,
    GenericLinkModule,
    TooltipIconModule,
    TooltipTextModule,
    ReactiveFormsModule,
    MatListModule,
    MatFormFieldModule,
    MatSelectModule,
    MatExpansionModule,
    RouterModule.forChild([
      {
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: { pageLabel: 'order', cxRoute: 'orderGuest' },
      },
      {
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'orderDetails' },
      },
    ]),
    ...moduleComponents,
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        OrderSummaryFlexComponent: {
          component: OrderDetailSummaryComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard, OrderDetailsAuthGuard],
        },
        InvoiceFlexComponent: {
          component: OrderDetailsInvoiceComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard, OrderDetailsAuthGuard],
        },
        SnappayInvoiceFlexComponent: {
          component: SnappayOrderDetailsInvoiceComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard, OrderDetailsAuthGuard],
        },
        PaymentReturnsFlexComponent: {
          component: OrderDetailsPaymentReturnComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard, OrderDetailsAuthGuard],
        },
        ConsignmentsFlexComponent: {
          component: OrderDetailsConsignmentsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard, OrderDetailsAuthGuard],
        },
        BackorderFlexComponent: {
          component: OrderDetailsBackorderComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard, OrderDetailsAuthGuard],
        },
      },
    } as CmsConfig | FeaturesConfig),
    OrderDetailsService,
    provideConfig({
      ...LaunchDialogModalLayoutConfig.OrderHistory,
    }),
  ],
  exports: [...moduleComponents],
})
export class OrderDetailsModule {}
